export default __webpack_public_path__ + "static/media/PH-C868.57e059ae.webp";